var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPirate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 462 462",
    style: {
      enableBackground: "new 0 0 462 462"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 150.427,
    cy: 189,
    r: 27.89
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 311.563,
    cy: 189,
    r: 27.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M150.427,222.89c-18.687,0-33.89-15.203-33.89-33.89s15.203-33.89,33.89-33.89 c18.688,0,33.891,15.203,33.891,33.89S169.115,222.89,150.427,222.89z M150.427,167.11c-12.07,0-21.89,9.82-21.89,21.89 s9.819,21.89,21.89,21.89s21.891-9.82,21.891-21.89S162.497,167.11,150.427,167.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M311.563,222.89c-18.688,0-33.891-15.203-33.891-33.89s15.203-33.89,33.891-33.89 c18.687,0,33.89,15.203,33.89,33.89S330.249,222.89,311.563,222.89z M311.563,167.11c-12.07,0-21.891,9.82-21.891,21.89 s9.82,21.89,21.891,21.89s21.89-9.82,21.89-21.89S323.633,167.11,311.563,167.11z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C6239"
    },
    d: "M280.355,284.97c0.19,0.05,0.39,0.09,0.58,0.14c10.46,2.53,20.19,6.93,28.83,12.81 c23.39,15.92,38.75,42.77,38.75,73.19V456h-47.04h-140.96h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 c8.64-5.88,18.37-10.28,28.83-12.81c0.19-0.05,0.39-0.09,0.58-0.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C6239"
    },
    d: "M160.515,332v124h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 C157.525,308.12,160.515,319.71,160.515,332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C6239"
    },
    d: "M348.515,371.11V456h-47.04V332c0-12.29,2.99-23.88,8.29-34.08 C333.155,313.84,348.515,340.69,348.515,371.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M280.355,284.97c-14.1,9.49-31.08,15.03-49.36,15.03s-35.26-5.54-49.36-15.03 c-0.19-0.13-0.39-0.26-0.58-0.4c-23.28-15.94-38.56-42.72-38.56-73.07V189v-51.5c0-48.877,39.623-88.5,88.5-88.5l0,0 c48.877,0,88.5,39.623,88.5,88.5V189v22.5c0,30.35-15.28,57.13-38.56,73.07C280.745,284.71,280.545,284.84,280.355,284.97z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M199.385,209.437c-1.58,0-3.13-0.64-4.24-1.75c-1.12-1.12-1.76-2.67-1.76-4.25s0.64-3.12,1.76-4.24 c1.39-1.39,3.46-2.03,5.41-1.64c0.39,0.08,0.76,0.19,1.13,0.34c0.36,0.15,0.71,0.34,1.03,0.55c0.33,0.22,0.64,0.47,0.91,0.75 c0.28,0.28,0.53,0.58,0.75,0.91s0.4,0.68,0.55,1.04c0.15,0.36,0.27,0.74,0.34,1.12c0.08,0.39,0.12,0.78,0.12,1.17 s-0.04,0.79-0.12,1.18c-0.07,0.38-0.19,0.76-0.34,1.12s-0.33,0.71-0.55,1.03c-0.22,0.33-0.47,0.64-0.75,0.92 C202.515,208.797,200.965,209.437,199.385,209.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M267.385,209.437c-0.39,0-0.79-0.04-1.17-0.11c-0.38-0.08-0.76-0.2-1.12-0.35 c-0.37-0.15-0.71-0.33-1.04-0.55c-0.33-0.22-0.64-0.47-0.91-0.74c-0.28-0.28-0.53-0.59-0.75-0.92c-0.22-0.32-0.4-0.67-0.55-1.03 s-0.27-0.74-0.34-1.12c-0.08-0.39-0.12-0.79-0.12-1.18s0.04-0.78,0.12-1.17c0.07-0.38,0.19-0.76,0.34-1.12s0.33-0.71,0.55-1.04 c0.22-0.33,0.47-0.63,0.75-0.91c0.27-0.28,0.58-0.53,0.91-0.75c0.33-0.21,0.67-0.4,1.04-0.55c0.36-0.15,0.74-0.26,1.12-0.34 c1.95-0.39,4.02,0.25,5.41,1.64c0.28,0.28,0.53,0.58,0.75,0.91s0.4,0.68,0.55,1.04s0.27,0.74,0.34,1.12 c0.08,0.39,0.12,0.78,0.12,1.17s-0.04,0.79-0.12,1.18c-0.07,0.38-0.19,0.76-0.34,1.12s-0.33,0.71-0.55,1.03 c-0.22,0.33-0.47,0.64-0.75,0.92C270.515,208.797,268.965,209.437,267.385,209.437z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M224.052,223c-3.313,0-6-2.687-6-6v-16.857c0-3.204-2.606-5.81-5.811-5.81h-28.58 c-3.313,0-6-2.687-6-6s2.687-6,6-6h28.58c9.82,0,17.811,7.989,17.811,17.81V217C230.052,220.313,227.365,223,224.052,223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M278.328,194.333h-24c-3.313,0-6-2.687-6-6s2.687-6,6-6h24c3.313,0,6,2.687,6,6 S281.642,194.333,278.328,194.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M242.995,258.333h-24c-3.313,0-6-2.687-6-6s2.687-6,6-6h24c3.313,0,6,2.687,6,6 S246.309,258.333,242.995,258.333z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.515,442c-3.313,0-6-2.687-6-6v-27c0-3.313,2.687-6,6-6s6,2.687,6,6v27 C334.515,439.313,331.828,442,328.515,442z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M157.165,309.92c-15.21,15.89-24.56,37.45-24.56,61.19V454 h-19.12v-82.89c0-30.42,15.35-57.27,38.74-73.19C154.205,301.74,155.865,305.75,157.165,309.92z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M166.515,456h-12V332c0-11.054-2.562-21.59-7.614-31.313l10.648-5.533 c5.865,11.289,8.966,24.03,8.966,36.846V456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M212.635,284.97c10.02,6.74,21.5,11.49,33.86,13.68 c-5.03,0.89-10.21,1.35-15.5,1.35c-18.28,0-35.26-5.54-49.36-15.03c-0.19-0.13-0.39-0.26-0.58-0.4 c-23.28-15.94-38.56-42.72-38.56-73.07V189c0-139,54.89-137.301,54.89-134.411l-10.384,15.807 c-15.364,23.387-15.305,53.174-0.958,76.231c2.423,3.895,10.151,17.294,10.019,20.366c-0.483,11.29-9.201,21.36-21.338,21.975 c-0.407,0.021-0.817,0.031-1.229,0.031v22.5c0,30.35,15.28,57.13,38.56,73.07C212.245,284.71,212.445,284.84,212.635,284.97z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#666666"
    },
    cx: 266.5,
    cy: 204,
    r: 27
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M272.5,237c-18.196,0-33-14.804-33-33s14.804-33,33-33s33,14.804,33,33S290.697,237,272.5,237z  M272.5,183c-11.579,0-21,9.42-21,21s9.421,21,21,21s21-9.42,21-21S284.079,183,272.5,183z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 295.315,
    y: 218.99,
    transform: "matrix(-0.8944 -0.4472 0.4472 -0.8944 480.0138 563.2964)",
    style: {
      fill: "#333333"
    },
    width: 22.36,
    height: 12.001
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M248.031,189.468c-0.675-0.305-16.733-7.674-34.568-25.896 c-16.343-16.698-37.396-46.144-44.882-91.597l11.84-1.95c13.324,80.894,71.959,108.24,72.55,108.507L248.031,189.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C6239"
    },
    d: "M368.108,83.063c-26.549-0.09-51.283-13.854-65.014-36.576 C288.485,22.31,261.997,6.104,231.68,6.001S174.766,21.923,159.992,46c-13.885,22.628-38.712,36.223-65.261,36.133l-0.511-0.002 c-5.168-0.018-9.371,4.157-9.389,9.325l-0.276,81.028l68.367-9.752c51.682-7.372,104.161-7.197,155.793,0.519l68.442,10.229 l0.276-81.028C377.451,87.284,373.276,83.081,368.108,83.063L368.108,83.063z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M132.788,72.198c-11.423,6.459-24.514,9.981-38.057,9.935l-0.51-0.002 c-5.168-0.018-9.371,4.157-9.389,9.325l-0.276,81.028l47.914-6.835L132.788,72.198z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M377.157,179.479c-0.295,0-0.591-0.021-0.887-0.066l-68.442-10.229 c-51.087-7.636-102.922-7.808-154.058-0.513l-68.367,9.752c-1.731,0.245-3.472-0.27-4.787-1.415 c-1.314-1.144-2.066-2.803-2.061-4.546l0.276-81.028c0.028-8.45,6.913-15.305,15.356-15.305c0.018,0,0.034,0,0.053,0l0.513,0.002 c0.079,0,0.159,0,0.238,0c24.353,0,47.283-12.732,59.886-33.271C171.358,16.007,199.942,0,231.385,0c0.106,0,0.209,0,0.315,0 c31.569,0.107,60.179,16.325,76.529,43.383c12.504,20.691,35.455,33.596,59.899,33.679c4.102,0.014,7.953,1.625,10.844,4.535 s4.475,6.772,4.461,10.874l-0.276,81.028c-0.006,1.743-0.77,3.396-2.091,4.532C379.971,178.972,378.582,179.479,377.157,179.479z  M229.044,151.327c26.924,0,53.836,1.997,80.558,5.99l61.579,9.203l0.253-74.088c0.003-0.896-0.343-1.741-0.975-2.377 c-0.633-0.636-1.475-0.988-2.371-0.991c-28.603-0.097-55.475-15.223-70.128-39.473C283.792,26.146,259.007,12.093,231.659,12 c-0.09,0-0.183,0-0.272,0c-27.241,0-52.001,13.868-66.28,37.138c-14.77,24.07-41.62,38.993-70.118,38.995c-0.094,0-0.183,0-0.277,0 l-0.513-0.002c-0.004,0-0.008,0-0.012,0c-1.844,0-3.349,1.499-3.354,3.346l-0.253,74.087l61.496-8.772 C177.617,153.149,203.336,151.327,229.044,151.327z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7B239"
    },
    cx: 230.995,
    cy: 71,
    r: 38
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M230.995,115c-24.262,0-44-19.738-44-44s19.738-44,44-44s44,19.738,44,44S255.257,115,230.995,115z  M230.995,39c-17.645,0-32,14.355-32,32s14.355,32,32,32s32-14.355,32-32S248.64,39,230.995,39z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M230.995,115c-24.262,0-44-19.738-44-44s19.738-44,44-44s44,19.738,44,44S255.257,115,230.995,115z  M230.995,39c-17.645,0-32,14.355-32,32s14.355,32,32,32s32-14.355,32-32S248.64,39,230.995,39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M358.5,153c-3.313,0-6-2.687-6-6v-40c0-3.313,2.687-6,6-6s6,2.687,6,6v40 C364.5,150.313,361.814,153,358.5,153z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.007,
    y: 32.992,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 344.1544 284.5364)",
    style: {
      fill: "#333333"
    },
    width: 11.999,
    height: 75.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.995,
    y: 64.998,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 344.1295 284.5377)",
    style: {
      fill: "#333333"
    },
    width: 75.999,
    height: 11.999
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M230.995,288c-3.313,0-6-2.687-6-6v-12c0-3.313,2.687-6,6-6s6,2.687,6,6v12 C236.995,285.313,234.309,288,230.995,288z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#664020"
    },
    points: "200.84,430.47 181.5,457 235.5,457  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.169,
    y: 427.335,
    transform: "matrix(-0.8081 -0.5891 0.5891 -0.8081 84.2431 914.9496)",
    style: {
      fill: "#333333"
    },
    width: 12.001,
    height: 32.832
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.34,
    y: 454.343,
    transform: "matrix(-0.8081 -0.589 0.589 -0.8081 151.6227 960.9979)",
    style: {
      fill: "#333333"
    },
    width: 11.999,
    height: 2.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 358.5,
    style: {
      fill: "#333333"
    },
    width: 12,
    height: 29.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664020"
    },
    d: "M309.76,297.92c-5.3,10.2-8.28,21.79-8.28,34.08v29l-41.22,56.54l-32.38-24.16l31.37-43.03 l7.36,13.65l31.89-71l0.62-1.28C302.82,293.54,306.37,295.62,309.76,297.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M259.25,350.35l-10.2-18.9l-16.98-31.46c17.88-0.21,34.47-5.72,48.29-15.02 c0.18,0.05,0.39,0.09,0.58,0.14c6.36,1.54,12.45,3.77,18.18,6.61L298.5,293l-31.89,71L259.25,350.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M232.07,299.99l16.98,31.46l-0.84,0.45L231,358.5l-17.09-26.83l-0.83-0.45l16.85-31.23 c0.35,0.01,0.71,0.01,1.06,0.01C231.35,300,231.71,300,232.07,299.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M229.93,299.99l-16.85,31.23L195.39,364l-31.89-71l-0.62-1.29c5.73-2.83,11.82-5.06,18.18-6.6 c0.18-0.05,0.38-0.09,0.58-0.14C195.47,294.28,212.06,299.78,229.93,299.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M230.99,306c-0.406,0-0.823-0.001-1.229-0.012c-18.372-0.215-36.205-5.762-51.473-16.04 c-0.214-0.139-0.475-0.314-0.729-0.502c-25.72-17.663-41.07-46.791-41.07-77.946v-47.28h12v47.28 c0,27.237,13.442,52.702,35.959,68.12c0.096,0.065,0.188,0.133,0.279,0.204c0.036,0.024,0.111,0.071,0.186,0.119 c13.398,9.019,28.962,13.859,45.086,14.048c0.391,0.01,0.69,0.008,0.99,0.009c0.304-0.002,0.61,0.001,0.916-0.007 c16.188-0.191,31.729-5.018,45.043-13.959c0.107-0.076,0.22-0.152,0.333-0.228l0.116-0.079c0.056-0.041,0.094-0.067,0.151-0.107 c22.511-15.414,35.95-40.879,35.95-68.12v-46.64h12v46.64c0,31.176-15.364,60.319-41.104,77.976 c-0.142,0.102-0.287,0.201-0.432,0.297l-0.106,0.072c-0.028,0.02-0.119,0.084-0.148,0.104 c-15.272,10.277-33.104,15.825-51.569,16.042C231.819,305.999,231.405,306,230.99,306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M307.48,456h-12V332c0-12.829,3.097-25.57,8.956-36.846l10.648,5.533 c-5.046,9.711-7.604,20.247-7.604,31.313V456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M348.52,462H113.48c-3.313,0-6-2.686-6-6v-84.89c0-31.306,15.463-60.521,41.364-78.15 c3.637-2.479,7.471-4.712,11.394-6.637c6.152-3.039,12.664-5.406,19.342-7.028c0.154-0.04,0.313-0.078,0.477-0.116l0.136-0.032 l2.896,11.646l-0.468,0.11c-0.061,0.017-0.087,0.024-0.148,0.039c-5.842,1.415-11.539,3.483-16.935,6.148 c-3.428,1.682-6.767,3.627-9.938,5.789c-22.618,15.395-36.119,40.901-36.119,68.232V450h223.04v-78.89 c0-27.33-13.509-52.836-36.135-68.229c-3.199-2.171-6.536-4.116-9.913-5.777c-5.397-2.675-11.093-4.746-16.944-6.163 c-0.038-0.009-0.075-0.019-0.113-0.029l-0.078-0.018c-0.197-0.044-0.392-0.091-0.571-0.141l3.189-11.568l-0.055-0.015 c0.214,0.049,0.36,0.083,0.492,0.117c6.703,1.626,13.228,4,19.394,7.056c3.857,1.898,7.68,4.125,11.344,6.611 c25.92,17.634,41.391,46.849,41.391,78.155V456C354.52,459.314,351.833,462,348.52,462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M195.391,370c-0.073,0-0.146-0.001-0.219-0.004c-2.282-0.083-4.319-1.455-5.256-3.538l-31.89-71 l10.947-4.917l26.909,59.912l29.833-55.295l10.568,5.684l-17.924,33.228l-17.69,32.78C199.62,368.795,197.589,370,195.391,370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M266.609,370c-2.199,0-4.23-1.206-5.28-3.152l-35.613-66.008l10.57-5.68l1.069,1.99l28.765,53.297 l26.907-59.906l10.947,4.917l-31.891,71c-0.937,2.083-2.974,3.455-5.257,3.538C266.754,369.999,266.681,370,266.609,370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M231,364.5c-0.007,0-0.014,0-0.021,0c-2.043-0.007-3.941-1.054-5.039-2.776l-17.09-26.83 l10.121-6.447l12.068,18.947l12.134-18.753l10.074,6.519l-17.21,26.6C234.932,363.468,233.035,364.5,231,364.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#333333"
    },
    points: "232.729,396.915 223.031,389.845 254.617,346.513 264.383,353.487 264.133,353.837  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.872,
    y: 354.3,
    transform: "matrix(-0.8081 -0.5891 0.5891 -0.8081 278.5186 869.3148)",
    style: {
      fill: "#333333"
    },
    width: 12.001,
    height: 69.972
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M235.045,462c-1.248,0-2.506-0.388-3.583-1.191l-36.79-27.45c-1.275-0.952-2.121-2.371-2.35-3.946 s0.177-3.176,1.129-4.451l27.45-36.79c0.951-1.276,2.371-2.121,3.946-2.35c1.574-0.23,3.176,0.178,4.451,1.129l36.787,27.447 c1.276,0.951,2.122,2.371,2.352,3.946s-0.177,3.177-1.129,4.453l-27.45,36.79C238.681,461.167,236.874,462,235.045,462z  M206.657,427.33l27.172,20.273l20.273-27.171l-27.172-20.274L206.657,427.33z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M362.5,462H99.73c-3.313,0-6-2.687-6-6s2.687-6,6-6H362.5c3.313,0,6,2.687,6,6 S365.814,462,362.5,462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M394.5,462h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S397.814,462,394.5,462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M78.5,462h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S81.814,462,78.5,462z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M230.373,429.879c-0.391,0-0.78-0.04-1.17-0.12c-0.381-0.08-0.761-0.19-1.12-0.34 c-0.36-0.15-0.71-0.34-1.04-0.55c-0.33-0.22-0.63-0.47-0.91-0.75c-1.12-1.11-1.76-2.66-1.76-4.24c0-0.39,0.04-0.79,0.12-1.17 c0.079-0.39,0.189-0.76,0.34-1.13c0.149-0.36,0.34-0.71,0.55-1.03c0.22-0.33,0.47-0.64,0.75-0.91c0.28-0.28,0.58-0.53,0.91-0.75 s0.68-0.4,1.04-0.55c0.359-0.15,0.739-0.27,1.12-0.34c0.779-0.16,1.569-0.16,2.35,0c0.38,0.07,0.76,0.19,1.12,0.34 s0.71,0.33,1.03,0.55c0.33,0.22,0.64,0.47,0.92,0.75c1.109,1.11,1.75,2.66,1.75,4.24s-0.641,3.12-1.75,4.24 c-0.28,0.28-0.59,0.53-0.92,0.75c-0.32,0.21-0.67,0.4-1.03,0.55s-0.74,0.26-1.12,0.34 C231.163,429.839,230.773,429.879,230.373,429.879z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPirate);
export default __webpack_public_path__ + "static/media/pirate.aee5e353fb3c3729b1546bd9cfb0ce5b.svg";
export { ForwardRef as ReactComponent };